export default __webpack_public_path__ + "images/labeling_tutorial_3_zoom-ycHKk.gif";